import { render, staticRenderFns } from "./SelectResidenceStatus.vue?vue&type=template&id=1a0063fc&"
import script from "./SelectResidenceStatus.vue?vue&type=script&lang=js&"
export * from "./SelectResidenceStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/boligvelger-v4/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a0063fc')) {
      api.createRecord('1a0063fc', component.options)
    } else {
      api.reload('1a0063fc', component.options)
    }
    module.hot.accept("./SelectResidenceStatus.vue?vue&type=template&id=1a0063fc&", function () {
      api.rerender('1a0063fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectResidenceStatus.vue"
export default component.exports